module.exports = __webpack_public_path__ + "2236469c0789f20230962996f9a12bec.svg";